// src/theme/theme.ts
import { createTheme } from '@mui/material/styles';

const PRIMARY_COLOR = '#2196f3';
const TEXT_PRIMARY = '#1C2A42';
const TEXT_SECONDARY = 'rgba(28,42,66,0.7)';
const PLACEHOLDER_COLOR = 'rgba(28,42,66,0.5)';

const theme = createTheme({
  palette: {
    primary: { main: PRIMARY_COLOR },
    text: {
      primary: TEXT_PRIMARY,
      secondary: TEXT_SECONDARY,
    },
    background: {
      default: '#ffffff',
      paper: '#f9f9f9',
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    body1: { color: TEXT_PRIMARY },
    body2: { color: TEXT_SECONDARY },
    caption: { color: TEXT_SECONDARY },
    button: { textTransform: 'none', fontWeight: 500 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        caption: { color: TEXT_SECONDARY },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            outline: `2px solid ${PRIMARY_COLOR}`,
            outlineOffset: '2px',
          },
        },
        input: {
          '&::placeholder': {
            color: PLACEHOLDER_COLOR,
          },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: `2px solid ${PRIMARY_COLOR}`,
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: `2px solid ${PRIMARY_COLOR}`,
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '6px 16px',
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root.Mui-focused fieldset': {
            borderColor: PRIMARY_COLOR,
          },
        },
      },
    },
  },
});

export default theme;
